<span class="agent-identity-label" [class.compact]="compact">
  <span class="agent-identity-label__display">
    {{ displayName || ('charts.labels.unknownAgent' | translate) }}
  </span>
  <span *ngIf="internalTag" class="agent-identity-label__internal">
    {{ internalTag }}
  </span>
</span>
